import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkingService } from '../networking.service';
import { AuthService } from '../../helper/services/auth.service';
import { API } from '../../data/api';
import { ClinicManager } from '../../data/models/ClinicManager';

@Injectable({
  providedIn: 'root'
})
export class ClinicManagerService {

  constructor(
    private networkingService: NetworkingService,
    private authService: AuthService,
    private router: Router
  ) {}

  async login(payload: { email: string, password: string }): Promise<ClinicManager> {
    return new Promise<ClinicManager>((resolve, reject) => {
      this.networkingService.postRequest(API.clinicManagerLogin, payload).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error)
      })
    })
  }

  async logoutUser(): Promise<void> {
    this.authService.clearSession()
    try {
      await new Promise<void>((resolve) => {
        this.networkingService.postRequest(API.clinicManagerLogout).subscribe({
          next: () => resolve(),
          error: () => resolve()
        })
      })
    } finally {
      await this.router.navigate(['/login'])
    }
  }

  async resetPassword(email: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.networkingService.putRequest(API.clinicManagerResetPassword, { email }).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    })
  }

  async alterPasswordAfterReset(auth_token: string, new_password: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.networkingService.putRequest(API.clinicManagerAlterPasswordAfterReset, { auth_token, new_password }).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    })
  }

  async changePassword(old_password: string, new_password: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.networkingService.putRequest(API.clinicManagerChangePassword, { old_password, new_password }).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    })
  }

  async alterEmail(email: string, password: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.networkingService.putRequest(API.clinicManagerAlterEmail, { email, password }).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    })
  }

  async alterName(name: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.networkingService.putRequest(API.clinicManagerAlterName, { name }).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    })
  }

  async getDetails(): Promise<ClinicManager> {
    return new Promise<ClinicManager>((resolve, reject) => {
      this.networkingService.getRequest<ClinicManager>(API.clinicManagerDetails).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error)
      })
    })
  }

  async deleteAccount(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.networkingService.deleteRequest(API.clinicManagerDelete).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    })
  }
}
